import { useMemo } from "react";

const COLORS = [
  "var(--kd-sunny)",
  "var(--kd-gold)",
  "var(--kd-green)",
  "var(--kd-purple)",
  "#FF6B9D",
  "#4FC3F7",
];

type ConfettiPiece = {
  left: number;
  delay: number;
  duration: number;
  color: string;
  size: number;
  rotate: number;
};

const N = 18;

/**
 * Pure CSS konfetti — N kolorowych divów spadających z góry. GPU-accelerated
 * (transform + opacity). Auto-cleanup gdy parent unmount.
 *
 * Respektuje prefers-reduced-motion (renderuje tylko 3 spokojne piece).
 */
export function Confetti() {
  const pieces = useMemo<ConfettiPiece[]>(() => {
    const reduceMotion =
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const count = reduceMotion ? 3 : N;
    return Array.from({ length: count }, () => ({
      left: Math.random() * 100,
      delay: Math.random() * 0.6,
      duration: 2 + Math.random() * 1.5,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      size: 6 + Math.random() * 6,
      rotate: Math.random() * 720,
    }));
  }, []);

  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 overflow-hidden"
    >
      {pieces.map((p, i) => (
        <span
          key={i}
          className="absolute top-0 block rounded-[2px]"
          style={{
            left: `${p.left}%`,
            width: `${p.size}px`,
            height: `${p.size * 1.6}px`,
            background: p.color,
            transform: `translateY(-20vh) rotate(${p.rotate}deg)`,
            animation: `kd-confetti-fall ${p.duration}s cubic-bezier(0.3, 0.6, 0.4, 1) ${p.delay}s forwards`,
          }}
        />
      ))}
    </div>
  );
}
